import HubPage from "@/pages/HubPage";
import { EXPORT } from "@/seo/exportContent";

export default function ExportPage() {
  return <HubPage id="export" content={EXPORT} metaKey="export" hero="/images/b2b.jpg" bg="/images/structuri-hero.jpg" />;
}
